<template>
  <div class="content-right">
    <column
      class="column1"
      :title="props.title"
      :ele_have_scrollbar="true"
      path="/layout/list/addedServices"
    >
      <template #abc>
        <rowBookCards
          v-for="(item, index) in mydata.recommend_list"
          :key="index"
          :info="item"
          :path="item.path"
          :outPage="true"
        >
          <template #rowBook>
            <img
              :class="item.img_type === 2 ? 'myrotate2' : ''"
              v-complete:src="item.img_url"
            />
          </template>
        </rowBookCards>
      </template>
    </column>
  </div>
</template>

<script setup>
import { reactive } from "vue";
import column from "@/components/column/index.vue";
import rowBookCards from "@/components/rowBookCards/index.vue";
// import { bookRecommend } from "@/api/addedServices/index.js";
// 引入淘题搜索接口
import { examSearchList } from "@/api/boutiqueTaobaoQuestions/listenBig/index.js";
// 推荐列表接口
import { getRecommendList } from "@/api/recommend/index.js";
import { useRoute } from "vue-router";
import { dictKeyWord } from "@/utils/dict.js";
const route = useRoute();

const mydata = reactive({
  recommend_list: {}, //推荐列表
  // 图片基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

const props = defineProps({
  title: {
    type: String,
    default: "超值推荐",
  },
});

////////////////////////////////////////////
// //推荐列表
// function getRecommendFn() {
//   // 使用标题在字典中进行匹配，得到对应的keyword值
//   let keyword = dictKeyWord[props.title];
//   getRecommendList({
//     keyword: keyword,
//     page: 1,
//     psize: 10,
//     column_key: route.path,
//   }).then((res) => {
//     mydata.valueBookArr = res.data.list;
//   });
// }

// getRecommendFn();

////////////////////////////////////////////

// 超值推荐
function getBottomRecommendData() {
  // // 调用接口
  // examSearchList({
  //   search: "", // 搜索查询
  //   grade_id: "", // 年级
  //   subject_id: "", //学科
  //   address_id: "", //地区
  //   type_id: "", //类型
  //   year_id: "", // 年份
  //   is_new: "", //是否最新（不传或者传0：否，1：是）
  //   is_recommended: "1", //是否推荐（不传或者传0：否，1：是）
  // }).then((res) => {
  //   mydata.valueBookArr = res.data.list.map((item) => {
  //     item.img_url = /^http/.test(item.image) ? item.image : mydata.VUE_APP_BASE_HOST + item.image
  //     return item;
  //   });
  // });

  // 使用标题在字典中进行匹配，得到对应的keyword值
  let keyword = dictKeyWord[props.title];
  // 调用接口
  getRecommendList({
    keyword: keyword,
    page: 1,
    psize: 10,
    column_key: route.path,
  }).then((res) => {
    mydata.recommend_list = res.data.list.map((item) => {
      // console.log( mydata.recommend_list,"超值推荐")
      // item.img_url = mydata.VUE_APP_BASE_HOST + item.image
      // item.img_url = item.image;
      item.img_url = /^http/.test(item.img_url)
        ? item.img_url
        : mydata.VUE_APP_BASE_HOST + item.img_url;
      item.path = item.buy_url_jd || item.buy_url;
      return item;
    });
  });
}
getBottomRecommendData();
</script>

<style scoped lang="scss">
.content-right {
  // border: 1px solid red;
  width: 375px;
  // 标题
  :deep(.box-column) {
    // margin-bottom: 16px;
    .column-title {
      > p {
        // display: none;
      }
    }
  }
  // 内容
  .column1 {
    .row-book {
      width:338px;
      display: flex;
      margin-bottom: 16px;
      img {
        // width: 120px;
        width: 90px;
        flex-shrink: 0;
        height: 120px;
        margin-right: 12px;
      }
      :deep(.box-p){
        >p:first-of-type{
          font-size:16px !important;
          line-height:24px;
          min-height:24px;
          margin-bottom:12px;
        }
         >p:nth-of-type(2){
          font-size:14px !important;
        }
      }
    }
    .row-book:nth-last-of-type(1) {
      margin-bottom: 0px;
    }
  }
}

:deep(.column-content.ele-have-scrollbar){
  height:400px;
  // border:1px solid red;
}
</style>
